import jqRequest from '../jqRequest'
import commUrls from '../urls/common'

export default {
  // 获取手机验证码
  getAuthCode(data) {
    return jqRequest.requestWithToken(commUrls.getAuthCode, data);
  },
  // 增加积分
  addScore(data) {
    return jqRequest.requestWithToken(commUrls.addScore, data);
  },
}